export const deviationConstants = {
  CREATING_DEVIATION: 'CREATING_DEVIATION',
  CREATING_DEVIATION_SUCCESS: 'CREATING_DEVIATION_SUCCESS',
  CREATING_DEVIATION_ERROR: 'CREATING_DEVIATION_ERROR',

  UPDATE_DEVIATION: 'UPDATE_DEVIATION',
  UPDATE_DEVIATION_SUCCESS: 'UPDATE_DEVIATION_SUCCESS',
  UPDATE_DEVIATION_ERROR: 'UPDATE_DEVIATION_ERROR',

  SUBMIT_DEVIATION_FOLLOWUP: 'SUBMIT_DEVIATION_FOLLOWUP',
  SUBMIT_DEVIATION_FOLLOWUP_SUCCESS: 'SUBMIT_DEVIATION_FOLLOWUP_SUCCESS',
  SUBMIT_DEVIATION_FOLLOWUP_ERROR: 'SUBMIT_DEVIATION_FOLLOWUP_ERROR',

  FETCHING_DEVIATIONS_FOR_BOAT: 'FETCHING_DEVIATIONS_FOR_BOAT',
  FETCH_DEVIATIONS_FOR_BOAT_SUCCESS: 'FETCH_DEVIATIONS_FOR_BOAT_SUCCESS',
  FETCH_DEVIATIONS_FOR_BOAT_ERROR: 'FETCH_DEVIATIONS_FOR_BOAT_ERROR',

  FETCHING_DEVIATION_TYPES: 'FETCHING_DEVIATION_TYPES',
  FETCH_DEVIATION_TYPES_SUCCESS: 'FETCH_DEVIATION_TYPES_SUCCESS',
  FETCHING_DEVIATION_TYPES_ERROR: 'FETCHING_DEVIATION_TYPES_ERROR',

  FETCHING_DEVIATION_STATUS: 'FETCHING_DEVIATION_STATUS',
  FETCH_DEVIATION_STATUS_SUCCESS: 'FETCH_DEVIATION_STATUS_SUCCESS',
  FETCHING_DEVIATION_STATUS_ERROR: 'FETCHING_DEVIATION_STATUS_ERROR',

  FETCHING_DEVIATION_PRIORITIES: 'FETCHING_DEVIATION_PRIORITIES',
  FETCH_DEVIATION_PRIORITIES_SUCCESS: 'FETCH_DEVIATION_PRIORITIES_SUCCESS',
  FETCHING_DEVIATION_PRIORITIES_ERROR: 'FETCHING_DEVIATION_PRIORITIES_ERROR',

  FETCH_DEVIATION_TAGS_LOADING: 'FETCH_DEVIATION_TAGS_LOADING',
  FETCH_DEVIATION_TAGS_SUCCESS: 'FETCH_DEVIATION_TAGS_SUCCESS',
  FETCH_DEVIATION_TAGS_ERROR: 'FETCH_DEVIATION_TAGS_ERROR',
} as const
